import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import React, { useState, useEffect } from 'react';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import { useLocation } from 'react-router-dom';

import './index.css';
import Phone from './Number';
import CallLogs from './CallLogs';

const Agents = (props) => {
  const location = useLocation();
  const [tab, setTab] = useState(() => {
    // Check URL for tab parameter on initial load
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('tab') === 'callLogs' ? 1 : 0;
  });

  // Handle URL changes (e.g., when navigating from softphone)
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('tab') === 'callLogs') {
      setTab(1);
    }
  }, [location.search]);

  const tabOptionsPhone = () => (
    <div className='tabs-box'>
      <div className='tabs-email'>
        <AppBar position="static">
          <Tabs value={tab} onChange={(e, value) => setTab(value)} aria-label="simple tabs example">
            <Tab label="Numbers" />
            <Tab label="Call logs" />
          </Tabs>
        </AppBar>
      </div>
    </div>
  )

  return (
    <div className='content phone-number-page'>
      <div className='main-container'>
        <div className='bottom-content-area phone-page'>
          <div className='tabs-content'>
            <TabPanel tab={tab} index={0}><Phone tabOptionsPhone={tabOptionsPhone} /></TabPanel>
            <TabPanel tab={tab} index={1}><CallLogs tabOptionsPhone={tabOptionsPhone} /></TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
}
function TabPanel(props) {
  const { children, tab, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={tab !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {tab === index && <Box p={3}> <Typography>{children}</Typography> </Box>}
    </div>
  )
}
TabPanel.propTypes = { children: PropTypes['node'], index: PropTypes['any']['isRequired'], value: PropTypes['any']['isRequired'] }

export default Agents;

